// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import AppointmentBookingStateTextWithIcon from './data'

export default function AppointmentBookingStateTextWithIconFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/AppointmentBookingStateTextWithIcon">
      <AppointmentBookingStateTextWithIcon {...props}>
        {children}
      </AppointmentBookingStateTextWithIcon>
    </Flow>
  )
}
